/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotColor {
    MONOCHROME = "MONOCHROME",
    IN_COLOR = "IN_COLOR",
    LIKE_TEMPLATE = "LIKE_TEMPLATE"
}
